import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

import FullScreenTransition from '../FullScreenTransition';
import Workspace from '../../Workspace';
import WorkspacePreview from './WorkspacePreview';

const FullScreenPreview = (props) => {
    const { onEnter, onExit, ...previewProps } = props;

    return (
        <FullScreenTransition onEnter={onEnter} onExit={onExit}>
            {() => (
                <Workspace>
                    <WorkspacePreview {...previewProps} />
                </Workspace>
            )}
        </FullScreenTransition>
    );
};

FullScreenPreview.propTypes = {
    onEnter: PropTypes.func,
    onExit: PropTypes.func,
};

FullScreenPreview.defaultProps = {
    onEnter: noop,
    onExit: noop,
};

export default FullScreenPreview;
